import React from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { SeoPagesList } from 'components/seo-pages/SeoPagesList/SeoPagesList'
import { SeoPageForm } from 'components/seo-pages/SeoPageForm/SeoPageForm'

export const SeoPages: React.FC = () => {
  const navigate = useNavigate()

  const handleCreateClick = () => {
    navigate('create')
  }

  const handleEditClick = (id: string) => {
    navigate(`edit/${id}`)
  }

  return (
    <Routes>
      <Route index element={<SeoPagesList onCreateClick={handleCreateClick} onEditClick={handleEditClick} />} />
      <Route path='create' element={<SeoPageForm />} />
      <Route path='edit/:id' element={<SeoPageForm />} />
      <Route path='*' element={<Navigate to='.' replace />} />
    </Routes>
  )
}